import { createContext, useContext, useState } from "react";

type Severity = "success" | "error" | "info" | "warning";

interface FeedbackState {
  open: boolean;
  message: string;
  severity: Severity;
}

interface FeedbackContextType {
  feedback: FeedbackState;
  showFeedback: (msg: string, severity?: Severity) => void;
  hideFeedback: () => void;
}

const FeedbackContext = createContext<FeedbackContextType | null>(null);

export const FeedbackProvider = ({ children }: any) => {
  const [feedback, setFeedback] = useState<FeedbackState>({
    open: false,
    message: "",
    severity: "success",
  });

  const showFeedback = (
    message: string,
    severity: Severity = "success"
  ) => {
    setFeedback({
      open: true,
      message,
      severity,
    });
  };

  const hideFeedback = () => {
    setFeedback((prev) => ({ ...prev, open: false }));
  };

  return (
    <FeedbackContext.Provider
      value={{ feedback, showFeedback, hideFeedback }}
    >
      {children}
    </FeedbackContext.Provider>
  );
};

export const useFeedback = () => {
  const ctx = useContext(FeedbackContext);
  if (!ctx) throw new Error("useFeedback must be used inside provider");
  return ctx;
};